Object.defineProperty(exports, "__esModule", {
  value: true
});

var AggsContainer_1 = require("./AggsContainer");

function AvgBucketPipeline(key, buckets_path) {
  return AggsContainer_1.AggsContainer(key, {
    buckets_path: buckets_path
  });
}

exports.AvgBucketPipeline = AvgBucketPipeline;